export const state = () => ({
  addSection: {
    active: false,
    index: null
  },
  activeSectionId: null,
  filePickerDialog: {
    visible: false,
    url: '',
    onConfirm: null
  },
  editFormDialog: {
    visible: false,
    rule: [],
    onConfirm: null
  },

  // 编辑盒相关
  sectionBox: { show: false },
  hoverBox: { show: false },
  activeBox: { show: false },
  // 对话框打开时要禁用elementsfrompoint
  canHover: true
})

// getters派生/计算属性
export const getters = {
  
}

// mutations只能同步操作
export const mutations = {
  showAddSection(state, payload) {
    state.addSection.active = true;
    state.addSection.index = payload?.index ?? null;
  },
  hideAddSection(state) {
    state.addSection.active = false;
  },
  showFilePickerDialog(state, { url, onConfirm }) {
    state.filePickerDialog.visible = true;
    state.filePickerDialog.url = url;
    state.filePickerDialog.onConfirm = onConfirm;
  },
  hideFilePickerDialog(state) {
    state.filePickerDialog.visible = false;
  },
  showEditFormDialog(state, { rule, onConfirm }) {
    state.editFormDialog.visible = true;
    state.editFormDialog.rule = rule;
    state.editFormDialog.onConfirm = onConfirm;
  },
  hideEditFormDialog(state) {
    state.editFormDialog.visible = false;
  },
  setActiveSectionId(state, { id }) {
    state.activeSectionId = id;
  },

  // 编辑盒相关
  setSectionBox(state, { box }) {
    state.sectionBox = box;
  },
  hideSectionBox(state) {
    state.sectionBox.show = false;
  },

  setHoverBox(state, { box }) {
    state.hoverBox = box;
  },
  hideHoverBox(state) {
    state.hoverBox.show = false;
  },

  setActiveBox(state, { box }) {
    state.activeBox = box;
  },
  hideActiveBox(state) {
    state.activeBox.show = false;
  },

  disableHover(state) {
    state.canHover = false;
  },
  enableHover(state) {
    state.canHover = true;
  },
}

// actions主要是异步操作
export const actions = {
  
}